import React from "react";
import "./style.css";
import { Resources } from "../../components/Resources";
import { SubjectDetail } from "../../components/SubjectDetails";
export const SubjectScreen = ({
  sub_code,
  full_marks,
  pass_marks,
  internal_marks,
  title,
  note_url,
  mq_url,
  cq_url,
  lw_url,
  soln_url,
  tb_url,
  assignment_url,
  ms_url,
}) => {
  return (
    <div className="container">
      <div className="subject grid">
        <div>
          <SubjectDetail
            sub_code={sub_code}
            full_marks={full_marks}
            pass_marks={pass_marks}
            internal_marks={internal_marks}
            title={title}
          />
          <Resources
            note_url={note_url}
            assignment_url={assignment_url}
            mq_url={mq_url}
            lw_url={lw_url}
            cq_url={cq_url}
            soln_url={soln_url}
            tb_url={tb_url}
            ms_url={ms_url}
          />
        </div>
        <div className="task-bar flex jc-c">
          <h2>Some item</h2>
        </div>
      </div>
    </div>
  );
};
